module.exports = new __parcel__URL__("calendar-dark.a0ed3c18.svg").toString();